export const GLOBAL_COUNTRY = 'Global';
export const STATUS_OK: number = 200;
export const STATUS_REDIRECT: number = 300;
export const ALL = 'all';
export const GLOBAL_LANGUAGE = 'English';
export const MAX_CART_QUANTITY = 999;
export const STATISTICS_REPORT_MAX_QUANTITY = 1;
